import { Application, Controller } from "@hotwired/stimulus";

class FormTermController extends Controller {
  static targets = ['button']

  toggleCheck(event) {
    this.buttonTarget.disabled = !event.target.checked;
  }
}

// Registered in admin.js
export { FormTermController };
